$(document).ready(function () {
    $(document).on('click', '.closes', deleteImage);
    $(document).on('click', '.js_choose_act', chooseAct);

    let type = $("#ticket_type > option:selected").val();

    if (type == 2) {
        $("#field").attr("hidden", false);
    } else {
        $("#field").attr("hidden", true);
    }
    $("#ticket_type").on('change', function () {
        type = $("#ticket_type > option:selected").val();

        if (type == 2) {
            $("#field").attr("hidden", false);
        } else {
            $("#field").attr("hidden", true);
        }
    });
});

function deleteImage() {
    let path = $(this).attr('path')
    $.post("/admin/settings/clients_interface_settings/image-delete", { imagePath: path }).done(function (data) {
        location.reload();
    });
}

function chooseAct(e) {
    var $link = $(this);
    $.get('/admin/settings/act_templates/list', function (response) {
        let inputOptions = [{text: 'Выберите акт', value: ''}];
        for (let k in response) {
            inputOptions.push({text: response[k], value: k});
        }
        var dialog = bootbox.prompt({
            title: $link.data('title'),
            size: "large",
            inputType: 'select',
            inputOptions: inputOptions,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> Отмена'
                },
                confirm: {
                    label: '<i class="fa fa-check"></i> Создать'
                }
            },
            callback: function callback(result) {
                if (result !== null && result !== '') {
                    var urlParams = new URLSearchParams(window.location.search);
                    urlParams.append('act_id', result);
                    var oldParams = new URLSearchParams($link.data('url').split("?")[1]);
                    if (oldParams.has("sales")) {
                        urlParams.append('sales', oldParams.get('sales'));
                    }
                    window.open($link.data('url').split("?")[0] + '?' + urlParams.toString());
                }
            }
        });
    });
    return false;
}

$(document).on('change', '#font_size', function () {
    var v = $(this).val();
    $('#example_size').css('font-size', v + 'px');
});

$(document).on('change', '#border_radius', function () {
    var v = $(this).val();
    $('#example_radius').css('border-radius', v + 'px');
});

$(document).on('change', '#opacity', function () {
    var v = $(this).val();
    $('#example_opacity').css('opacity', v);
});

$(document).on('click', '.button_color', function () {
    var v = $(this).val();
    $('#button_color').val(v);
});

$(document).on('click', '.font_color', function () {
    var v = $(this).val();
    $('#font_color').val(v);
});

$(document).on('click', '.background_color', function () {
    var v = $(this).val();
    $('#background_color').val(v);
});

$(document).on('click', '.font_color_authorization_buttons', function () {
    var v = $(this).val();
    $('#font_color_authorization_buttons').val(v);
});